module.exports = __webpack_public_path__ + "media/images/icons/country_flags/za-57ed656aa5c93d478f182e2421e3f165.svg";